import { Select, ISelect } from ".";
import { useEffect, useState } from "react";
import { textChooser } from "../../../util/textChooser";
import { getSituationList } from "../../../apis/public.api";
import { formatValuesForSelect } from "../../../helpers/utilities";

interface FormationSituationProps extends ISelect { }

export const FormationSituation = (props: FormationSituationProps) => {
  const [situationList, setSituationList] = useState([]);

  async function getSituation() {
    const response = await getSituationList();

    formatValuesForSelect(setSituationList, response)
  }

  useEffect(() => {
    getSituation()
  }, [])

  return (
    <Select
      {...props}
      label={props?.label ?? textChooser("txt181")}
      values={situationList}
      currentValue={props.currentValue}
    />
  )
}